var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3333 6.538V4C13.3333 3.82319 13.2631 3.65362 13.1381 3.5286C13.013 3.40357 12.8435 3.33333 12.6667 3.33333C11.3333 3.33333 9.67333 2.54 8.50667 1.52C8.36543 1.39933 8.18576 1.33303 8 1.33303C7.81424 1.33303 7.63457 1.39933 7.49333 1.52C6.33333 2.53333 4.66667 3.33333 3.33333 3.33333C3.15652 3.33333 2.98695 3.40357 2.86193 3.5286C2.7369 3.65362 2.66667 3.82319 2.66667 4V8.66667C2.66667 11.2533 4.07133 12.836 6 13.864",
    stroke: "#525252",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6667 11.3333V10C12.6667 9.64638 12.5262 9.30724 12.2761 9.05719C12.0261 8.80714 11.687 8.66667 11.3333 8.66667C10.9797 8.66667 10.6406 8.80714 10.3905 9.05719C10.1405 9.30724 10 9.64638 10 10V11.3333",
    stroke: "#525252",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3333 11.3333H9.33333C8.96514 11.3333 8.66667 11.6318 8.66667 12V14C8.66667 14.3682 8.96514 14.6667 9.33333 14.6667H13.3333C13.7015 14.6667 14 14.3682 14 14V12C14 11.6318 13.7015 11.3333 13.3333 11.3333Z",
    stroke: "#525252",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.012b90bcbc350bc43be173aaa8f3baab.svg";
export { ForwardRef as ReactComponent };